const ROOT = document.documentElement
let pendingFrame
let lastApplied = {}

function toPrecise(num) {
  return Number(num).toFixed(2)
}

function applyViewportUnits(values) {
  const { vw, dvh, svh, lvh, vh } = values

  if (
    lastApplied.vw === vw &&
    lastApplied.dvh === dvh &&
    lastApplied.svh === svh &&
    lastApplied.lvh === lvh &&
    lastApplied.vh === vh
  ) {
    return
  }

  const style = ROOT.style
  style.setProperty('--vw', `${vw}px`)
  style.setProperty('--dvh', `${dvh}px`)
  style.setProperty('--svh', `${svh}px`)
  style.setProperty('--lvh', `${lvh}px`)
  style.setProperty('--vh-in-px', `${vh}px`)

  lastApplied = values
}

function measureViewport() {
  const vv = window.visualViewport

  const width = vv ? vv.width : window.innerWidth
  const height = vv ? vv.height : window.innerHeight
  const clientHeight = document.documentElement.clientHeight
  const innerHeight = window.innerHeight

  return {
    dvh: toPrecise(height * 0.01),
    lvh: toPrecise(innerHeight * 0.01),
    svh: toPrecise(clientHeight * 0.01),
    vh: toPrecise(innerHeight * 0.01),
    vw: toPrecise(width * 0.01)
  }
}

function updateViewportUnits() {
  if (pendingFrame) {
    return
  }

  pendingFrame = requestAnimationFrame(() => {
    applyViewportUnits(measureViewport())
    pendingFrame = undefined
  })
}

window.addEventListener('resize', updateViewportUnits, {
  passive: true
})
window.addEventListener('orientationchange', updateViewportUnits, {
  passive: true
})
window.addEventListener('pageshow', updateViewportUnits)

if (window.visualViewport) {
  window.visualViewport.addEventListener('resize', updateViewportUnits, {
    passive: true
  })
  window.visualViewport.addEventListener('scroll', updateViewportUnits, {
    passive: true
  })
}

updateViewportUnits()
